import { FILTER_KEYS } from '@/services/filter-layer-service/constants'
import { FIELDS } from '@/fish/lib/taxonomy-constants'
import { AllModes } from '@/types/modes'

/**
 * This file defines the quick filter keys to use for each activity mode in each vertical that has modes.
 * A quick filter is a standard filter type that is elevated in the UI higher than the main "all filters card",
 * in order to make it more quickly accessible to the user. Quick filters are typically to most important or commonly
 * used filters for a given activity mode.
 */

type ModeQuickFilter = {
  type: string
  label: string
}

type QuickFiltersByMode = { [key in AllModes]?: ModeQuickFilter[] }

const fishQuickFiltersByMode = Object.freeze<QuickFiltersByMode>({
  [AllModes.Freshwater]: [
    {
      type: FILTER_KEYS[FIELDS.FISH_TYPES],
      label: 'Species',
    },
    {
      type: FILTER_KEYS[FIELDS.AMENITIES],
      label: 'Access',
    },
  ],
})
/**
 * Get the quick filters for the current app mode
 * @returns - array of quick filters
 */
export const getModeQuickFilters = (): ModeQuickFilter[] => {
  return fishQuickFiltersByMode[AllModes.Freshwater] ?? []
}
